module.exports = __webpack_public_path__ + "static/media/DOPIBOJ_pathogene.50889280.png";